module.exports = __webpack_public_path__ + "img/logo_mini2.fec3a498.png";